/**
 * Create PDF File.
 * @author Arkadiusz Krauzowicz <a.krauzowicz@zoovu.com>
 */
export default class FilePDF {
    /**
     * Create file from Base64 String.
     * @param   {String}  encodedBytes - Encoded base64 String.
     * @returns {FilePDF}              - PDF File.
     */
    public static fromBase64(encodedBytes) {
        const byteCharacters = atob(encodedBytes);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new FilePDF([byteArray]);
    }

    /**
     * Create file from binary file.
     * @param   {String}  binaryFile - Binary file as String.
     * @returns {FilePDF}            - PDF File.
     */
    public static fromBinary(binaryFile) {
        const length = binaryFile.length;

        const blobParts = new Uint8Array(length);

        for (let i = 0; i < length; i++) {
            blobParts[i] = binaryFile.charCodeAt(i);
        }

        return new FilePDF([blobParts]);
    }

    private blob: Blob;

    /**
     * Create instance of a Blob.
     * @param {Array}  blobParts - Objects, or a mix of any of such objects, that will be put inside the Blob.
     * @param {Object} options   - is an optional BlobPropertyBag dictionary which may specify the endings attribute.
     */
    constructor (blobParts, options = {}) {
        /** Type must be always 'application/pdf' */
        this.blob = new Blob(blobParts, {...options, type: "application/pdf"});
    }

    /**
     * Invoke in browser downloading the file.
     * @param {String} fileName - Name of downloaded file.
     */
    public download = (fileName = "assistant-summary") => {
        /**
         * Downloading the file depends on the browser
         * IE handles it differently than chrome/webkit
         */
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(this.blob, `${fileName}.pdf`);
        } else {
            const data = window.URL.createObjectURL(this.blob);
            const link = document.createElement("a");
            link.href = data;
            link.download = fileName;

            const clickHandler = function () {
                /** For Firefox it is necessary to delay revoking the ObjectURL */
                setTimeout(() => {
                    window.URL.revokeObjectURL(data);
                    this.removeEventListener("click", clickHandler);
                }, 100);
            };

            link.addEventListener("click", clickHandler, false);
            link.click();
        }
    }
}
